module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_9016.f87880aa.png";